// extracted by mini-css-extract-plugin
export default {"loginLeftSideBackground":"styles_loginLeftSideBackground__S6ggB"};